import '../scss/main.scss';

import { headerSlider } from './components/headerSlider';
import { matchHeights } from './components/matchHeights';
import { asyncLoadMorePosts } from './components/asyncLoadMorePosts';
import { enableHamburgerMenu } from './components/enableHamburgerMenu';
import { categoryDropdown } from './components/categoryDropdown';
import { searchEnabler } from './components/searchEnabler';
import { showMobileMenu } from './components/showMobileMenu';

document.addEventListener("DOMContentLoaded",()=> {
    categoryDropdown();
    headerSlider();
    matchHeights();
    asyncLoadMorePosts();
    enableHamburgerMenu();
    searchEnabler();
    showMobileMenu();
})
